function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/helpers/interopRequireDefault.js
// module id = 1489
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21 22 25